export default "__VITE_ASSET__650f2359__"